// Translations
import form from '../sections/form/translations/en'

// Translation: Verification > Landing (English)
export default Object.freeze({
	sections: { form }
})
